/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { useEffect, useLayoutEffect, useRef, useState } from "react"
// @ts-ignore
import RangeTouch from "rangetouch"

interface IProps {
  value: number
  onChange(value: number): void
  className?: string
}
export function RangeInput({ value, onChange, className }: IProps) {
  const [val, setVal] = useState(value)
  const [isMousedDown, setIsMousedDown] = useState(false)
  const shouldUseExternalValue = useRef(false)
  const timeoutRef = useRef<number>(null)
  const ref = useRef<any>(null)

  useEffect(() => {
    if (shouldUseExternalValue.current) {
      ;(timeoutRef as any).current = setTimeout(() => {
        shouldUseExternalValue.current = false
        setIsMousedDown(false)
      }, 100)
    }
  }, [value])

  useLayoutEffect(() => {
    new RangeTouch(ref.current, {})
  }, [])

  const calcValue = isMousedDown ? val : value
  const rangeValue = isNaN(calcValue) ? 0 : calcValue

  return (
    <input
      ref={ref}
      type="range"
      value={rangeValue}
      onChange={e => setVal(Number(e.target.value))}
      min={0}
      max={100}
      step={0.05}
      className={className}
      onMouseDown={() => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }
        setIsMousedDown(true)
      }}
      onTouchStart={() => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }
        setIsMousedDown(true)
      }}
      onMouseUp={() => {
        shouldUseExternalValue.current = true
        onChange(val)
      }}
      onTouchEnd={() => {
        shouldUseExternalValue.current = true
        onChange(val)
      }}
      css={css`
        position: relative;
        z-index: 2;
        -webkit-text-size-adjust: 100%;
        direction: ltr;
        overflow: visible;
        font: inherit;
        box-sizing: inherit;
        touch-action: manipulation;
        -webkit-appearance: none;
        background: 0 0;
        border: 0;
        border-radius: 26px;
        display: block;
        height: 13px;
        min-width: 0;
        padding: 0;
        transition: box-shadow 0.3s ease;
        width: 100%;
        outline: none;
        cursor: pointer;
        &::-webkit-slider-runnable-track {
          background-color: rgba(255, 255, 255, 0.25);
          border: 0;
          border-radius: calc(5px / 2);
          height: 5px;
          -webkit-transition: box-shadow 0.3s ease;
          transition: box-shadow 0.3s ease;
          -webkit-user-select: none;
          user-select: none;
          background-image: linear-gradient(to right, #36b5f0 ${rangeValue}%, transparent 0);
        }
        &::-moz-range-track {
          background-color: rgba(255, 255, 255, 0.25);
          border: 0;
          border-radius: calc(5px / 2);
          height: 5px;
          -webkit-transition: box-shadow 0.3s ease;
          transition: box-shadow 0.3s ease;
          -webkit-user-select: none;
          user-select: none;
          background-image: linear-gradient(to right, #36b5f0 ${rangeValue}%, transparent 0);
        }
        &::-webkit-slider-thumb {
          background: #fff;
          border: 0;
          border-radius: 100%;
          box-shadow: 0 1px 1px rgba(35, 40, 47, 0.15), 0 0 0 1px rgba(35, 40, 47, 0.2);
          height: 13px;
          position: relative;
          -webkit-transition: all 0.2s ease;
          transition: all 0.2s ease;
          width: 13px;
          -webkit-appearance: none;
          margin-top: calc(((13px - 5px) / 2) * -1);
        }
        &::-moz-range-thumb {
          background: #fff;
          border: 0;
          border-radius: 100%;
          box-shadow: 0 1px 1px rgba(35, 40, 47, 0.15), 0 0 0 1px rgba(35, 40, 47, 0.2);
          height: 13px;
          position: relative;
          -webkit-transition: all 0.2s ease;
          transition: all 0.2s ease;
          width: 13px;
          -webkit-appearance: none;
          margin-top: calc(((13px - 5px) / 2) * -1);
        }
      `}
    />
  )
}
